/**
 * Les dates « calendrier » (contrats, factures : colonnes @db.Date) arrivent
 * de l'API à minuit UTC, soit la veille au soir à l'heure du Québec. On les
 * lit comme un jour civil local pour ne pas afficher le jour précédent.
 */
const DAY_ONLY = /^\d{4}-\d{2}-\d{2}(T00:00:00(\.000)?Z)?$/;
export function parseDay(v) {
    if (typeof v === 'string' && DAY_ONLY.test(v))
        return new Date(`${v.slice(0, 10)}T12:00:00`);
    return new Date(v);
}
/** Date du jour (fuseau local) au format AAAA-MM-JJ. */
export function todayIso() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
//# sourceMappingURL=dates.js.map